<template> 
  <div>
    <div class="content flex-row-fluid mt-2" id="kt_content">
        <!-- <StatsBar></StatsBar> -->
        <div class="card">
            <div class="card-body pt-0">
                <div class="row px-0">
                    <div class="col-lg-9">
                        <form class="form fv-plugins-bootstrap5 fv-plugins-framework rounded-2">
                            <div class="fv-row mb-7 row">
                                <div class="col-lg">
                                    <label class="fs-6 fw-bold form-label mt-3">
                                        <span>{{ $t('start_date') }}</span>
                                    </label>
                                    <Datepicker :locale="$datepickerLocale()"  textInput :textInputOptions="{ format: 'dd.MM.yyyy' }" v-maska="'##.##.####'" v-model="form.start_date" inputClassName="form-control" format="dd.MM.yyyy" autoApply :clearable="false" weekNumbers @update:modelValue="getData(true)" :monthChangeOnScroll="'inverse'" :enableTimePicker="false" ></Datepicker>  
                                </div>
                                <div class="col-lg">
                                    <label class="fs-6 fw-bold form-label mt-3">
                                        <span>{{ $t('end_date') }}</span>
                                    </label>
                                    <Datepicker :locale="$datepickerLocale()"  textInput :textInputOptions="{ format: 'dd.MM.yyyy' }" v-maska="'##.##.####'" v-model="form.end_date" inputClassName="form-control" format="dd.MM.yyyy" autoApply :clearable="false" weekNumbers @update:modelValue="getData(true)" :monthChangeOnScroll="'inverse'" :enableTimePicker="false" ></Datepicker>
                                </div>
                                <div class="col-lg">
                                    <label class="fs-6 fw-bold form-label mt-3">
                                        <span>{{ $t('activepassive') }}</span>
                                    </label>
                                    <Select2 v-model="form.is_active" :options="acitivePassiveList" @select="getData(true)" :settings="{width: '100%', dropdownParent: '#kt_modal_transaction_list .modal-content'}" />
                                </div>
                                <div class="col-lg">
                                    <label class="fs-6 fw-bold form-label mt-3">
                                        <span>{{ $t('position') }}</span>
                                    </label>
                                    <Select2 v-model="form.position" :options="positionList" @select="getData(true)" :settings="{width: '100%', dropdownParent: '#kt_modal_transaction_list .modal-content'}" />
                                </div>
                                <div class="col-lg">
                                    <label class="fs-6 fw-bold form-label mt-3">
                                        <span>{{ $t('offer_type') }}</span>
                                    </label>
                                    <Select2 v-model="form.offer_type" :options="offerTypeFilteredList" @select="getData(true)" :settings="{width: '100%', dropdownParent: '#kt_modal_transaction_list .modal-content'}" />
                                </div>
                                <div class="col-lg">
                                    <label class="fs-6 fw-bold form-label mt-3">
                                        <span>{{ $t('sales_type') }}</span>
                                    </label>
                                    <Select2 v-model="form.sales_type" :options="salesTypeList" @select="getData(true)" :settings="{width: '100%', dropdownParent: '#kt_modal_transaction_list .modal-content'}" />
                                </div>
                            </div>
                        </form>
                    </div>
                    <div class="col-lg-3" v-if="this.$isCredentialActive(81,'R')">                        
                        <div class="d-flex justify-content-end align-items-center mt-8" data-kt-customer-table-toolbar="base"> 
                            <Popper hover placement="bottom">
                                <button type="button" class="btn btn-light border border-gray-300 btn-icon me-3" @click="this.setCriteriasToDefault()">
                                    <i class="bi bi-eraser-fill fs-4"> </i>
                                </button>
                                <template #content>
                                    <span class="text-gray-800"> {{ $t('reset_all_criterias') }} </span>
                                </template>
                            </Popper>
                            <button v-if="this.$getUser().is_allow_list_all_data" type="button" class="btn btn-light-primary border border-primary" @click="getData(false)" data-kt-indicator="on">
                                <span class="svg-icon svg-icon-muted"><svg width="16" height="15" viewBox="0 0 16 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <rect y="6" width="16" height="3" rx="1.5" fill="currentColor"/>
                                <rect opacity="0.3" y="12" width="8" height="3" rx="1.5" fill="currentColor"/>
                                <rect opacity="0.3" width="12" height="3" rx="1.5" fill="currentColor"/>
                                </svg>
                                </span>
                                <span v-if="!this.isListProgressing"> {{ $t('list_offer') }}</span> 
                                <span class="indicator-progress" v-if="this.isListProgressing">
                                    {{ $t('getting_data') }} <span class="spinner-border spinner-border-sm align-middle ms-2"></span>
                                </span> 
                            </button>
                        </div>
                    </div>
                </div>
                <div class="separator my-5 mt-0 border-gray-300"></div>
                <div class="dataTables_wrapper dt-bootstrap4 no-footer">                    
                    <!-- <ListOptions :name="this.$options.name" ref="listOptionComponent"></ListOptions> -->
                    <DxDataGrid id="gridContainer" :key="$i18n.locale" :show-borders="true" 
                                key-expr="id" 
                                :data-source="offerList" 
                                :allow-column-reordering="true"  
                                :allow-column-resizing="true" 
                                :column-auto-width="true" 
                                :row-alternatin-enabled="true"
                                :hover-state-enabled="true" 
                                :show-row-lines="true" 
                                :scrolling="{ mode: 'virtual' }"
                                @exporting="this.$onExporting($event , 'Offer-Transaction-List')"  
                                :ref="'dataGrid'"
                                :customize-columns="onCustomizeColumn"> 

                                <DxFilterRow :visible="true"/>
                                <DxHeaderFilter :visible="true"/>
                                <DxGroupPanel :visible="true"/>      
                                <DxExport :enabled="false" :formats="['xlsx', 'pdf']" :allow-export-selected-data="false"/>
                                <DxPaging :page-size="10"/>
                                <DxPager :visible="false" :allowed-page-sizes="pageSizes" :show-page-size-selector="showPageSizeSelector" :show-info="true" :show-navigation-buttons="true"/>
                                <DxSearchPanel :visible="false"/>
                                <DxColumn data-field="offer_date" :caption="$t('record_date')" data-type="date" alignment="right" format="dd.MM.yyyy" header-cell-template="record-date-header" cell-template="offer_date-cell-template"/> 
                                <DxColumn data-field="is_active" :caption="$t('is_active')" cell-template="is_active-cell-template" :width="100" /> 
                                <DxColumn data-field="offer_type_name" :caption="$t('offer_type')" header-cell-template="invoice-type-header" cell-template="offer_type_name-cell-template"/> 
                                <DxColumn data-field="position_name" :caption="$t('position')" cell-template="position_name-cell-template"/> 
                                <DxColumn data-field="is_repeated_invoice" :caption="$t('repeated_invoice')" alignment="center" header-cell-template="is_repeated_invoice-header" cell-template="is_repeated_invoice-cell-template"/> 
                                <DxColumn data-field="offer_no" :caption="$t('offer_number')" header-cell-template="invoice-number-header" cell-template="offer_no-cell-template"/> 
                                <DxColumn data-field="account_name" :caption="$t('account')" cell-template="account_name-cell-template"/> 
                                <DxColumn data-field="gross_amount" :sorting-method="this.$numericSort" :caption="$t('grand_total')" header-cell-template="grand-total-header" alignment="right" cell-template="gross_amount-cell-template"/> 
                                <DxColumn data-field="rate" :caption="$t('rate')" :sorting-method="this.$numericSort" alignment="right" cell-template="rate-cell-template"/> 
                                <DxColumn data-field="gross_amount_local" :sorting-method="this.$numericSort" :caption="$t('grand_total_local')" header-cell-template="grand-total-local-header" alignment="right" cell-template="gross_amount_local-cell-template"/>
                                <DxColumn data-field="invoice_description" :caption="$t('invoice_detail')" header-cell-template="invoice-description-header" cell-template="invoice_description-cell-template"/> 
                                <DxColumn data-field="sales_type" :caption="$t('sales_type')" alignment="left" header-cell-template="sales-type-header" cell-template="sales_type-cell-template"/> 
                                <DxColumn data-field="created_by" :caption="$t('created_by')" cell-template="created-by-cell-template"/> 


                                <!-- Yerel para birimi gösterimi için özel sütun şablonu oluşturulur --> 
                                <template #headerLocalTemplate="{ data: data }">
                                    <div v-html="setColumnTemplateForLocal(data)"></div> 
                                </template>

                                <template #record-date-header>
                                    <div>{{ $t('record_date') }}</div>
                                </template>
                                <template #invoice-type-header>
                                    <div>{{ $t('offer_type') }}</div>
                                </template>
                                <template #invoice-description-header>
                                    <div>{{ $t('invoice_detail') }}</div>
                                </template>
                                <template #sales-type-header>
                                    <div>{{ $t('sales_type') }}</div>
                                </template>
                                <template #invoice-number-header>
                                    <div>{{ $t('offer_number') }}</div>
                                </template>
                                <template #grand-total-header>
                                    <div>{{ $t('grand_total') }}</div>
                                </template>
                                <template #grand-total-local-header>
                                    <div>{{ $t('grand_total_local') }}</div>
                                </template> 
                                <template #is_repeated_invoice-header>
                                    <div>{{ $t('repeated_invoice') }}</div>
                                </template> 

                                 <!-- Cell Templates -->
                                <template #offer_date-cell-template="{ data }">
                                    <a href="#" class="text-gray-800 text-hover-primary" @click="updateOffer(data.data.id)">
                                        {{ previewDate(data.data.offer_date) }} 
                                    </a>
                                </template>
                                 <template #offer_type_name-cell-template="{ data }">
                                     <a href="#" class="text-gray-800 text-hover-primary" @click="updateOffer(data.data.id)">
                                        <div>
                                            <span class="badge badge-circle badge-light me-3">
                                                <i class="bi bi-pencil text-gray-900"></i> 
                                            </span> 
                                            {{ data.data.offer_type_name }} 
                                        </div>
                                    </a>
                                </template>
                                 <template #position_name-cell-template="{ data }">
                                    <a href="#" class="text-gray-800 text-hover-primary" @click="updateOffer(data.data.id)">
                                        <span class="badge" 
                                            :class="{'badge-info': data.data.position == 1, 'badge-success': data.data.position == 2 || data.data.position == 6, 'badge-primary': data.data.position == 3, 'badge-danger': data.data.position == 4 || data.data.position == 7}">
                                            {{ data.data.position_name }} 
                                        </span>
                                    </a>
                                </template>
                                 <template #sales_type-cell-template="{ data }"> 
                                    <a href="#" class="text-gray-800 text-hover-primary" @click="updateOffer(data.data.id)">
                                        <span v-if="data.data.sales_type == 1"> {{ $t('domestic') }} </span>
                                        <span v-if="data.data.sales_type == 2"> {{ $t('overseas') }} </span>
                                    </a>
                                </template> 
                                <template #offer_no-cell-template="{ data }"> 
                                    <a href="#" class="text-gray-800 text-hover-primary" @click="updateOffer(data.data.id)">
                                        {{ data.data.offer_no }} 
                                    </a>
                                </template>
                                <template #is_active-cell-template="{ data }"> 
                                    <a href="#" class="text-gray-800 text-hover-primary" @click="updateOffer(data.data.id)">
                                        <span v-if="data.data.is_active">                                          
                                            <i class="bi bi-check-circle fs-3 text-success"></i>
                                        </span>  
                                        <span v-if="!data.data.is_active">
                                          <i class="bi bi-x-circle fs-3 text-danger"></i>
                                        </span> 
                                    </a>
                                </template>
                                 <template #account_name-cell-template="{ data }">
                                    <a href="#" class="text-gray-800 text-hover-primary" @click="updateOffer(data.data.id)">
                                        {{ data.data.account_name }}  
                                    </a>
                                </template>
                                 <template #gross_amount-cell-template="{ data }">
                                    <a href="#" class="text-gray-800 text-hover-primary" @click="updateOffer(data.data.id)">
                                        {{ data.data.gross_amount }} {{ data.data.currency }} 
                                    </a>
                                </template> 
                                <template #rate-cell-template="{ data }"> 
                                    <a href="#" class="text-gray-800 text-hover-primary" @click="updateOffer(data.data.id)">
                                        {{ data.data.rate }}
                                    </a>
                                </template>
                                 <template #invoice_description-cell-template="{ data }">
                                     <a href="#" class="text-gray-800 text-hover-primary text-center" @click="updateOffer(data.data.id)">
                                        <div v-if="data.data.invoice_description !== '' && data.data.invoice_description !== null && data.data.invoice_description !== undefined">
                                            <i class="bi bi-check-circle text-success"></i> {{ $t('invoice_issued') }}
                                        </div>
                                        <div v-if="data.data.invoice_description !== '' && data.data.invoice_description !== null && data.data.invoice_description !== undefined">
                                            {{ data.data.invoice_description }}
                                        </div>
                                    </a>
                                </template>
                               <template #gross_amount_local-cell-template="{ data }">
                                    <a href="#" class="text-gray-800 text-hover-primary" @click="updateOffer(data.data.id)">
                                        {{ data.data.gross_amount_local }} {{ data.data.local_currency }} 
                                    </a>
                                </template> 
                               <template #process_type_name-cell-template="{ data }">
                                    <a href="#" class="text-gray-800 text-hover-primary" @click="updateOffer(data.data.id)">
                                        {{ data.data.process_type_name }}
                                    </a>
                                </template> 
                               <template #is_repeated_invoice-cell-template="{ data }">
                                    <a href="#" class="text-gray-800 text-hover-primary" @click="updateOffer(data.data.id)">
                                        <span v-if="data.data.is_repeated_invoice">                                          
                                            <i class="bi bi-check-circle fs-3 text-success"></i>
                                        </span>  
                                        <span v-if="!data.data.is_repeated_invoice">
                                          <i class="bi bi-x-circle fs-3 text-danger"></i>
                                        </span> 
                                    </a>
                                </template>
                                <template #created-by-cell-template="{ data }">
                                    <a href="#" class="text-gray-800 text-hover-primary" @click="updateOffer(data.data.id)">
                                        {{ data.data.created_by }}
                                    </a>
                                </template> 

                                <DxSummary :calculate-custom-summary="setSummaries">
                                    <DxTotalItem column="id" summary-type="count" :display-format="`${$t('record')}: {0}`" show-in-column="offer_date"/>
                                    <DxGroupItem
                                        :show-in-group-footer="true"
                                        name="gross_amount_local"
                                        summary-type="custom"
                                        show-in-column="gross_amount_local"
                                        display-format="{0}"
                                    /> 
                                    <DxTotalItem
                                        name="gross_amount_local"
                                        summary-type="custom"
                                        show-in-column="gross_amount_local"
                                        display-format="{0}"
                                    />
                                </DxSummary>
                                <DxStateStoring
                                        :enabled="true"
                                        type="custom"
                                        :storage-key="this.storageKey"
                                        :ref="dataGrid" 
                                        :saving-timeout="1000"
                                        :custom-load="LoadDXState"
                                    />
                    </DxDataGrid>   
                </div> 
            </div>
        </div> 
    </div>  
  </div>  
</template>

<script>
import axios from 'axios';
import moment from 'moment';

import { DxDataGrid, DxFilterRow, DxHeaderFilter, DxGroupPanel, DxExport, DxPaging, DxPager, DxColumn, DxSearchPanel, DxSummary, DxTotalItem, DxGroupItem, DxStateStoring } from 'devextreme-vue/data-grid';
// import { DxPopover } from 'devextreme-vue/popover';
 
export default {
  name: "offerList",
  components:{
        DxDataGrid, DxFilterRow, DxHeaderFilter, DxGroupPanel, DxExport, DxPaging, DxPager, DxColumn, DxSearchPanel, DxSummary, DxTotalItem, DxGroupItem, DxStateStoring
  },
 data() {
    return { 
        storageKey: 'dx_' + this.$options.name,
        localCurrency: null,
        isOpenActionsDropdown: false,      
        page: 1,
        page_size: 10,
        form:  {
            start_date: moment().subtract((parseInt(this.$getUser().list_date_range)), 'days'),
            end_date: moment(),
            position: 0,
            sales_type: 0,
            offer_type: 0,
            is_active: -1,
            account_id: null
        },
        offerList: [],
        searchbar: '',
        pageSize: 10,
        pageIndex: 0,
        isListProgressing: false,
        positionList: [
            { id: 0, text: this.$t('all')},
            { id: 1, text: this.$t('offer')},
            { id: 2, text: this.$t('order')},
            { id: 3, text: this.$t('to_delivery')},
            { id: 4, text: this.$t('cancel')},
            { id: 5, text: this.$t('delivered')},
            // { id: 6, text: this.$t('activated')},
            // { id: 7, text: this.$t('deactivated')},
        ],
        offerTypeList: [
            { id: 0, text: this.$t('all')},
            { id: 1, text: this.$t('sales')},
            { id: 2, text: this.$t('purchase')}
        ],
        salesTypeList: [
            { id: 0, text: this.$t('all')},
            { id: 1, text: this.$t('domestic')},
            { id: 2, text: this.$t('overseas')},
        ],
        acitivePassiveList:[
            { id: -1, text: this.$t('all')}, 
            { id: 1, text: this.$t('active')}, 
            { id: 0, text: this.$t('passive')}
        ]
    };
  },
  computed: { 
    setColumnTemplateForLocal(){
        return (value)=>{
            const captionValue = value.column.caption.replace(this.$t('local'), ' ');
            return this.localCurrency == null ? this.$t(captionValue) : this.localCurrency + '<br>' + this.$t(captionValue);          
        }
   },
     searchableList() { 
        return this.offerList.filter(p => { 
            return p.account_name.toLowerCase().indexOf(this.searchbar.toLowerCase()) != -1 || 
                    p.offer_type_name.toLowerCase().indexOf(this.searchbar.toLowerCase()) != -1 ||
                    p.offer_no.toLowerCase().indexOf(this.searchbar.toLowerCase()) != -1;
            }
        ).slice((this.page - 1) * this.page_size, this.page * this.page_size);
    },
    previewDate(){
      return (value)=>{
       if (value) {
          return moment(new Date(value)).format('DD.MM.YYYY')
        }
      }
    },
    showPageSizeSelector() {
        return this.offerList.length > this.pageSize;
    },
    pageSizes() {
        let arr = [];
        let x = 1;
        let loop = (this.offerList.length / this.pageSize);
        for (let i = 1; i <= loop && i <= 5; i++) {
            arr.push(this.pageSize * x);
            x++;
        }
        if(loop > 5) arr.push(100);
        if(loop > 1) arr.push('all');
        return arr;
    },
    offerTypeFilteredList() {
        if(!this.$isCredentialActive(82, 'R', 81) && !this.$isCredentialActive(83, 'R', 81)) {
            return this.offerTypeList.filter(p => { 
                return p.id !== 1;
            });
        }
        if(!this.$isCredentialActive(84, 'R', 81) && !this.$isCredentialActive(85, 'R', 81)) {
            return this.offerTypeList.filter(p => { 
                return p.id !== 2;
            });
        }
        return this.offerTypeList;
    },
  },
  methods: { 
    getData(isAuto) {    
        this.offerTypeList = [{ id: 0, text: this.$t('all')}];
        if(this.$isCredentialActive(82, 'R', 81)) this.offerTypeList.push({ id: 1, text: this.$t('sales')});
        if(this.$isCredentialActive(83, 'R', 81)) this.offerTypeList.push({ id: 2, text: this.$t('purchase')});

        if(isAuto && this.$getUser().is_allow_list_all_data) return;
        this.offerList = [];
        this.$Progress.start(); 
        this.isListProgressing = true;
        this.form.start_date = (this.form.start_date == null || this.form.start_date == '') ? moment() : this.form.start_date;
        this.form.end_date = (this.form.end_date == null || this.form.end_date == '') ? moment() : this.form.end_date;
        const params = {
            session_id: this.$getUser().session_id,
            start_date: this.form.start_date,
            end_date: this.form.end_date,
            offer_type: this.form.offer_type,
            sales_type: this.form.sales_type,
            is_active: this.form.is_active,
            position: this.form.position,
            account_id: this.form.account_id,
            invoiceTypes: []
        };
        if(params.position == 0) { params.position = null }
        if(params.offer_type == 0) { params.offer_type = null }
        if(params.sales_type == 0) { params.sales_type = null }
        params.start_date = moment(params.start_date).format('YYYY-MM-DD[T]HH:mm:ss');
        params.end_date = moment(params.end_date).format('YYYY-MM-DD[T]HH:mm:ss'); 
        axios.post('api/Offer/GetOffersByFilter', params, {'Content-Type': 'application/json'})
        .then((response) => {
            this.offerList = response.data;
            this.page = 1;
            this.localCurrency = this.$getUser().currency_code; 
            this.$Progress.finish();
            setTimeout(() => {
                this.isListProgressing = false;
            }, 500);
        })
        .catch(() => {
            this.$Progress.finish();
            setTimeout(() => {
                this.isListProgressing = false;
            }, 500);
        })
    },
    updateOffer(id){
        this.$setSessionStorage('record_id', id);
        this.$parent.$refs.closeTransactionListModal.click();
        if (this.$route.name == 'OfferUpdate') {
            this.$router.go(0);
        } else {
            this.$router.push({ name: 'OfferUpdate' });
        }
    },
    setCriteriasToDefault(accountId) {   
        this.offerList = [];
        if((accountId === null || accountId === undefined || accountId === '-1')  && !this.$getUser().is_allow_list_all_data) return;
        this.form = {
            start_date: moment().subtract((parseInt(this.$getUser().list_date_range)), 'days'),
            end_date: moment(),
            sales_type: 0,
            is_active: -1,
            offer_type: 0,
            position: 0,
            account_id: (accountId !== undefined && accountId !== '' && accountId !== '-1') ? accountId : null
        };
        this.getData();
    },
    onClickDropdown(item) {
        this.offerList.forEach(element => {
            if (item.id !== element.id) {
                element.isOpenActionsDropdown = false;
            }
        });
        item.isOpenActionsDropdown = !item.isOpenActionsDropdown;
    },
    onCustomizeColumn(e){
        if(e){
            if(!e._isUpdated){
                if(e.length > 0){ 
                    e._isUpdated = true;
                }
                e.forEach((column) => {   
                     if(column.dataField == 'gross_amount_local'){ 
                         column.caption = this.$t('grand_total_local');
                         column.headerCellTemplate = 'headerLocalTemplate';
                     }
                });  
            } 
        } 
    },
    onEnterPopover(item, type){ 
         this.offerList.forEach((value) => { 
            value.type = type;
            if (item.id === value.id) {
                value.isPopover = true; 
                if (type == 'company') {
                    value.isVisibleCompany = true;
                    value.isVisibleController = false;
                    value.isVisibleSystem = false;
                }
                if (type == 'controller') {
                    value.isVisibleCompany = false;
                    value.isVisibleController = true;
                    value.isVisibleSystem = false;
                }
                if (type == 'system') {
                    value.isVisibleCompany = false;
                    value.isVisibleController = false;
                    value.isVisibleSystem = true;
                }
            }
        });  
    },
    onLeavePopover(value){
        value.isPopover = false; 
        value.isVisibleCompany = false;
        value.isVisibleController = false;
        value.isVisibleSystem = false;
    },
    setSummaries(options){
        if(options.name == "gross_amount_local"){
            if(options.summaryProcess === 'start'){
                options.totalValue = 0;
            }
            else if(options.summaryProcess === 'calculate'){ 
                var gross_amount_local = parseFloat(options.value.gross_amount_local.replaceAll(',', ''));
                (options.totalValue += gross_amount_local); 
            }
            else if(options.summaryProcess === 'finalize'){
                var currencyInfo = this.localCurrency == null || this.localCurrency == '' ? '' : this.localCurrency;
                options.totalValue = Intl.NumberFormat('en-US', { minimumFractionDigits: 2 }).format(options.totalValue) +' '+ currencyInfo;
            }
        } 
    },
    /** DX STATE OPERATIONS **/  
    LoadDXState() {
        return JSON.parse(sessionStorage.getItem(this.storageKey));
    }, 
  }
}; 
</script>